var exports = {
  "TT": "ProfileCardUserInfo.module__userInfoContainer___THd5SU",
  "S7": "ProfileCardUserInfo.module__nameRow___THd5SU",
  "oo": "ProfileCardUserInfo.module__nameButton___THd5SU",
  "uV": "ProfileCardUserInfo.module__nameButtonClickable___THd5SU",
  "fC": "ProfileCardUserInfo.module__badgeContainer___THd5SU",
  "NW": "ProfileCardUserInfo.module__userTagWrapper___THd5SU",
  "Hq": "ProfileCardUserInfo.module__actionsContainer___THd5SU",
  "Fj": "ProfileCardUserInfo.module__usernameRow___THd5SU",
  "sR": "ProfileCardUserInfo.module__inlinePronouns___THd5SU",
  "xO": "ProfileCardUserInfo.module__usernameButton___THd5SU",
  "hI": "ProfileCardUserInfo.module__pronouns___THd5SU",
  "sM": "ProfileCardUserInfo.module__srOnly___THd5SU",
};

module.exports = exports;
